import axios from 'axios';
import _ from 'lodash';
// import AsyncStorage from '@react-native-community/async-storage';
import {getItem, setItem} from '../utils/handleStorage';
import CONST from '../config/const'

// 옵션 우선순위 : 3위. 인스턴스 생성시 설정 / 2위. 인스턴스 default 설정 / 1위. 인스턴스 메소드 호출시 옵션
export const instance = axios.create({
  baseURL: CONST.HOST
});

// axios.defaults.baseURL = 'https://api.example.com'; // set axios global default config
// instance.defaults.baseURL = 'https://api.example.com'; // set instance default config after instance created

// https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
// By default, axios serializes JavaScript objects to JSON.
// To send data in the application/x-www-form-urlencoded format instead, you can use one of the following options.
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

instance.interceptors.request.use(
  async response => {
    // go then()
    const token = await getItem('session');

    // if (_.isNil(token)) {
    //   // 로그인으로 보내던 하면된다
    //   return Promise.reject(new Error('no user accessToken'));
    // }

    response.headers.Authorization = 'Bearer ' + token;
    return response;
  },
  error => {
    // go catch()
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log('axios response interceptor, response: ', response);

    return response;
  },
  error => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // console.log('axios response interceptors, error: ', error);

    // error.message = error.message + '[messeage edited]';
    return Promise.reject(error);
  },
);

export default instance;
